const durationUnit = function (unit, count) {
  if (count === 1) {
    return {
      DAY: 'Tag',
      HOUR: 'Stunde',
      MONTH: 'Monat',
      WEEK: 'Woche',
      YEAR: 'Jahr'
    }[unit]
  }
  return {
    DAY: 'Tage',
    HOUR: 'Stunden',
    MONTH: 'Monate',
    WEEK: 'Wochen',
    YEAR: 'Jahre'
  }[unit]
}

export { durationUnit }

export default {
  methods: {
    durationUnit
  }
}
